var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-radio"},_vm._l((_vm.radioData),function(item,index){return _c('div',{key:index,staticClass:"row",on:{"click":function($event){return _vm.change(item)}}},[_c('div',{class:['radio', item.status ? 'radio-active' : 'radio-normal']}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v(_vm._s(item.label))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-398861eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/servey/compoents/MyRadio.vue
// module id = null
// module chunks = 